"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17.24",
    height: "17.24",
    viewBox: "0 0 17.24 17.24",
    alt: "x"
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "Gruppe_440",
      "data-name": "Gruppe 440",
      transform: "translate(2.12 2.12)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        id: "Linie_23",
        "data-name": "Linie 23",
        x2: "12.093",
        y2: "13",
        transform: "translate(0.453)",
        fill: "none",
        stroke: props.color ? props.color : '#a1a0ae',
        strokeLinecap: "round",
        strokeWidth: "3"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        id: "Linie_24",
        "data-name": "Linie 24",
        x2: "12.093",
        y2: "13",
        transform: "translate(13 0.454) rotate(90)",
        fill: "none",
        stroke: props.color ? props.color : '#a1a0ae',
        strokeLinecap: "round",
        strokeWidth: "3"
      })]
    })
  }));
};

var _default = CloseIcon;
exports.default = _default;